/**
 * Materiais publicados da plataforma (A12, Onda 7.2). Espelha
 * `originei-produtos/dto/ConteudoPublicado*` — campo a campo, sem inventar.
 */

/** Espelha `entity/TipoConteudoPublicado`. */
export type TipoConteudoPublicado = 'GUIA_COMERCIAL' | 'CHECKLIST_DOCUMENTAL' | 'ROTEIRO_REUNIAO'

/** Espelha `entity/PerfilVisibilidade` — quem pode ler a peça. */
export type PerfilVisibilidade = 'ADMIN' | 'GERENTE' | 'OPERADOR' | 'CONSULTOR'

export const TIPOS_CONTEUDO: Record<TipoConteudoPublicado, string> = {
  GUIA_COMERCIAL: 'Guia comercial',
  CHECKLIST_DOCUMENTAL: 'Checklist documental',
  ROTEIRO_REUNIAO: 'Roteiro de reunião',
}

export const PERFIS_VISIBILIDADE: Record<PerfilVisibilidade, string> = {
  ADMIN: 'Administrador',
  GERENTE: 'Gerente',
  OPERADOR: 'Operador',
  CONSULTOR: 'Consultor',
}

/** Espelha `dto/ConteudoPublicadoResponse`. */
export interface ConteudoPublicado {
  id: string
  /** null = material da plataforma (todos os tenants). */
  tenantId: string | null
  /** null = vale para todos os produtos. */
  produtoId: string | null
  produtoNome: string | null
  tipo: TipoConteudoPublicado
  titulo: string
  /** Arquivo no serviço de documentos — baixado pelo endpoint auditado, nunca por URL direta. */
  documentoId: string
  versao: number
  substituiId: string | null
  vigenciaInicio: string
  vigenciaFim: string | null
  perfis: PerfilVisibilidade[]
  publicadoPor: string
  publicadoEm: string
  ativo: boolean
  /** Calculado no backend: ativo e dentro da vigência hoje. */
  vigente: boolean
}

/** Espelha `dto/ConteudoPublicadoRequest`. */
export interface ConteudoPublicadoRequest {
  tenantId?: string | null
  produtoId?: string | null
  tipo: TipoConteudoPublicado
  titulo: string
  documentoId: string
  vigenciaInicio?: string | null
  vigenciaFim?: string | null
  perfis: PerfilVisibilidade[]
}

/** Espelha `dto/ConteudoPublicadoEdicaoRequest` — o arquivo não muda por edição; muda por nova versão. */
export interface ConteudoPublicadoEdicaoRequest {
  tenantId?: string | null
  produtoId?: string | null
  tipo: TipoConteudoPublicado
  titulo: string
  vigenciaInicio: string
  vigenciaFim?: string | null
  perfis: PerfilVisibilidade[]
}

/** Espelha `dto/NovaVersaoConteudoRequest`. */
export interface NovaVersaoConteudoRequest {
  documentoId: string
  titulo?: string | null
  vigenciaInicio?: string | null
  vigenciaFim?: string | null
}

/** Espelha `dto/ConteudoResumoResponse` — os KPIs da tela, contados da mesma tabela da lista. */
export interface ConteudoResumo {
  publicados: number
  vigentes: number
  produtosCobertos: number
  vencendoEm30Dias: number
}
